<mat-form-field [appearance]="appearance" floatLabel="always" [class.margin-bottom-1]="hint != null" [class.mat-form-field-readonly]="readonly" [hintLabel]="maxLength ? (hint || 'Max Length:') : hint">
  <mat-label>{{label}}</mat-label>
  <textarea matInput [placeholder]="placeholder" [formControl]="formControl" [rows]="minRows" [errorStateMatcher]="matcher" [readonly]="readonly"></textarea>
  <mat-hint *ngIf="maxLength" align="end">{{value?.length || 0}}/{{maxLength}}</mat-hint>
  <mat-hint *ngIf="!maxLength">{{hint}}</mat-hint>
  <mat-error [innerHTML]="errors"></mat-error>
</mat-form-field>
